import React from "react"
import { FaRupeeSign } from "react-icons/fa"
import { MdArrowForward } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import { useTable } from "react-table"
import tw from "tailwind-styled-components"

const Tables = ({ recentTransaction }) => {
    const navigate = useNavigate();

    const columns = React.useMemo(
        () => [
            {
                Header: "Name",
                accessor: (row) => row,
                Cell: ({ value }) => {
                    const truncateText = (text, maxLength = 20) =>
                        text && text.length > maxLength
                            ? text.substring(0, maxLength) + "..."
                            : text || "";
                    return (
                        <div>
                            <div className="font-medium" title={value.paidByName}>
                                {truncateText(value.paidByName, 20)}
                            </div>
                            <div className="text-xs text-gray-500" title={value.propName}>
                                {truncateText(value.propName, 20)}
                            </div>
                        </div>
                    );
                },
            },

            {
                Header: "Amount",
                accessor: (row) => row,
                Cell: ({ value }) => {
                    return (
                        <div>
                            <div className="font-medium flex">{'₹' + value.amount.toLocaleString()}</div>
                        </div>
                    )
                }
            },
            {
                Header: "Date",
                accessor: "paidDate",
                Cell: ({ value }) => {
                    const date = new Date(value);
                    return date.toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                    });
                },
            },

        ],
        [],
    )

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns,
        data: recentTransaction,
    })

    return (
        <TableContainer>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-800">Recent Transaction</h2>
                <Button onClick={() => navigate("/landlord/collections")}>See All <MdArrowForward className="text-primary-color ml-1 text-lg" /></Button>
            </div>

            <Table {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps()} key={column.id}>
                                    {column.render("Header")}
                                </Th>
                            ))}
                        </tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()}>
                    {rows.length > 0 ? (
                        rows.map((row) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()} key={row.id}>
                                    {row.cells.map((cell) => (
                                        <Td {...cell.getCellProps()} key={cell.column.id}>
                                            {cell.render("Cell")}
                                        </Td>
                                    ))}
                                </tr>
                            )
                        })
                    ) : (
                        <tr>
                            <Td colSpan={3} className="text-center py-4">
                                No transactions found
                            </Td>
                        </tr>
                    )}
                </Tbody>
            </Table>
        </TableContainer>
    )
}

const TableContainer = tw.div`bg-white p-4 shadow-md rounded-lg`
const Table = tw.table`min-w-full table-auto`
const Thead = tw.thead`bg-gray-200`
const Tbody = tw.tbody``
const Th = tw.th`px-4 py-2 text-left text-gray-600 text-sm font-medium uppercase tracking-wider`
const Td = tw.td`px-4 py-2 text-sm text-gray-700`
const Button = tw.button`rounded-lg bg-gray-50 p-2 text-sm text-gray-600 hover:text-primary-color flex justify-center items-center`
export default Tables

